import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { last, takeWhile } from 'rxjs/operators';
import { OpusJob } from '../models';
import { jobStates } from '../models';

@Component({
  selector: 'opus-jobs-table-row',
  templateUrl: './opus-jobs-table-row.component.html'
})
export class OpusJobsTableRowComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isEditing: boolean;
  @Input() updatingOpusJobs: boolean;
  @Input() isOdd: boolean;
  @Input() isLast: boolean;
  @Input() chargeItm: OpusJob;
  @Input() item: FormGroup;

  //alive = true;

  ngOnInit() {}

  ngOnDestroy() {
    /*  this.alive = false;*/
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isEditing !== undefined) {
      if (changes.isEditing.currentValue === false) {
        //	when the editor is closed, sych up with the actual shipping charge model
        if (!this.updatingOpusJobs) {
          this.resetForm();
        }

        this.item.disable();
      } else if (changes.isEditing !== undefined && changes.isEditing.currentValue === true) {
        if (this.updatingOpusJobs) {
          this.updatingOpusJobs = false;
          this.isEditing = false;
        }
        this.item.enable();
      }
    }
  }

  resetForm() {
    this.item.reset({
      id: this.chargeItm.id,
      enabled: this.chargeItm.enabled,
      name: this.chargeItm.name,
      state: this.chargeItm.state,
      nextRunAt: this.chargeItm.nextRunAt,
      startedAt: this.chargeItm.startedAt,
      completedAt: this.chargeItm.completedAt,
      message: this.chargeItm.message,
      schedule: this.chargeItm.schedule,
      retryCount: this.chargeItm.retryCount,
      retryDelaySeconds: this.chargeItm.retryDelaySeconds,
      lastModifiedBy: this.chargeItm.lastModifiedBy,
      lastModifiedAt: this.chargeItm.lastModifiedAt,
      updateApplyIntervalInSeconds: this.chargeItm.updateApplyIntervalInSeconds
    });
  }

  static BuildItem(charge: OpusJob): FormGroup {
    return new FormGroup({
      id: new FormControl(charge.id),
      enabled: new FormControl(charge.enabled),
      name: new FormControl(charge.name),
      state: new FormControl(charge.state),
      nextRunAt: new FormControl(charge.nextRunAt),
      startedAt: new FormControl(charge.startedAt),
      completedAt: new FormControl(charge.completedAt),
      message: new FormControl(charge.message),
      schedule: new FormControl(charge.schedule),
      retryCount: new FormControl(charge.retryCount),
      retryDelaySeconds: new FormControl(charge.retryDelaySeconds),
      lastModifiedBy: new FormControl(charge.lastModifiedBy),
      lastModifiedAt: new FormControl(charge.lastModifiedAt),
      updateApplyIntervalInSeconds: new FormControl(charge.updateApplyIntervalInSeconds)
    });
  }

  getJobStateName(state: number) {
    const jobState = jobStates.find(js => js.value === state);
    return jobState ? jobState.key : 'Unknown';
  }

  getIntervalFromDateDifference(date1Str: Date, date2Str: Date) {
    const date1 = new Date(date1Str);
    const date2 = new Date(date2Str);
    const diff = date2.getTime() - date1.getTime();
    // Convert the difference in milliseconds to eg. 1 day 4h 2m 3s
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    const milliseconds = diff % 1000;

    let str = '';
    if (days > 1) {
      str += days + 'd ';
    }
    if (hours > 1) {
      str += hours + 'h ';
    }
    if (minutes > 1) {
      str += minutes + 'm ';
    }
    if (seconds > 1) {
      str += seconds + 's ';
    }

    if (milliseconds > 1) {
      str += milliseconds + 'ms';
    }

    return days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
  }
}
